import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { useTranslation } from "react-i18next";
import { useFetchMarcas } from "../../utilities/hooks/useFetchMarcas.jsx";
import { CategoryFlyout } from "./CategoryFlyout.jsx";
import { navbarData, politicasAnticorrupcion } from "../../config/config.js";
import { authContext } from "../Context/AuthContext";
import { useGetCategorias } from "../../utilities/hooks/Categorias/useGetCategorias.jsx";
import { useLocation } from "react-router-dom";

const apiProductos = process.env.REACT_APP_API_PRODUCTOS;

export const Barra1 = () => {
  const country = process.env.REACT_APP_COUNTRY;
  // Países donde "Tienda" es un link directo a /store en lugar del desplegable de marcas y categorías
  // (JM, TT y PR no muestran el menú Tienda)
  const tiendaDirecta = country !== "JM" && country !== "TT" && country !== "PR";
  // "Contáctanos" y "Trabaja con nosotros" viven dentro de "Nosotros" (que no se muestra en JM, TT ni PR)
  const contactoEnNosotros = country !== "JM" && country !== "TT" && country !== "PR";
  const { token } = useContext(authContext);
  const [t] = useTranslation("global");
  const { marcasMapeadas } = useFetchMarcas(apiProductos);
  const [showDropdown, setShowDropdown] = useState(false);
  const [codPath, setCodPath] = useState('');
  const [manPath, setManPath] = useState('');
  const [procPath, setProcPath] = useState('');
  const { categorias, fetchCategorias } = useGetCategorias();
  const location = useLocation();

  // Menú mobile (panel lateral): navbar controlado para poder cerrarlo al navegar
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    setMenuAbierto(false);
  }, [location.pathname, location.search]);

  // Si la ventana pasa a ancho de escritorio con el panel abierto, se cierra (evita dejar el fondo y el scroll bloqueados)
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 992px)");
    const alCambiar = (e) => {
      if (e.matches) setMenuAbierto(false);
    };
    if (mq.addEventListener) mq.addEventListener("change", alCambiar);
    else mq.addListener(alCambiar);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", alCambiar);
      else mq.removeListener(alCambiar);
    };
  }, []);

  // Estados para controlar los dropdowns
  const [showTiendaDropdown, setShowTiendaDropdown] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // 'marcas' o 'categorias'
  const [showCategoriasDropdown, setShowCategoriasDropdown] = useState(false);
  const [showMarcasDropdown, setShowMarcasDropdown] = useState(false);

  // Función para manejar el toggle de cada dropdown
const handleDropdownToggle = (dropdownName, isOpen) => {
  setActiveDropdown(isOpen ? dropdownName : null);
};


  // Función para cerrar todos los dropdowns
  const closeAllDropdowns = () => {
    setShowTiendaDropdown(false);
    setShowCategoriasDropdown(false);
    setShowMarcasDropdown(false);
  };

  // Efecto para cerrar dropdowns al cambiar de ruta o hacer click afuera
  useEffect(() => {
    closeAllDropdowns();
  }, [location]);

  useEffect(() => {
    const handleClickOutsideNav = (event) => {
      // Si el click fue fuera de cualquier dropdown, cerramos sub-dropdowns
      if (!event.target.closest('.dropdown')) {
        closeAllDropdowns();
      }
    };
    document.addEventListener('click', handleClickOutsideNav);
    return () => {
      document.removeEventListener('click', handleClickOutsideNav);
    };
  }, []);

  useEffect(() => {
    setCodPath(politicasAnticorrupcion[country]?.cod || '');
    setManPath(politicasAnticorrupcion[country]?.man || '');
    setProcPath(politicasAnticorrupcion[country]?.proc || '');
  }, []);

  useEffect(() => {
    // Cada vez que cambie la ruta, cierra el dropdown de categorías
    setShowDropdown(false);
  }, [location]);

  const handleSubDropdownClick = (dropdownName, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (dropdownName === "marcas") {
      setShowMarcasDropdown((prev) => {
        const nextState = !prev;
        if (nextState) setShowCategoriasDropdown(false);
        return nextState;
      });
    } else if (dropdownName === "categorias") {
      setShowCategoriasDropdown((prev) => {
        const nextState = !prev;
        if (nextState) {
          setShowMarcasDropdown(false);
          fetchCategorias(true);
        }
        return nextState;
      });
    }
  };
  

  return (
    <div className="bordeBarraNav">
      <Navbar
        expand="lg collapseOnSelect"
        className={`lightNav`}
        expanded={menuAbierto}
        onToggle={setMenuAbierto}
      >
        <Container fluid>
          <Navbar.Toggle aria-controls="navbarScroll" />
          {/* Escritorio: links en línea. Mobile: panel lateral izquierdo (drawer) */}
          <Navbar.Offcanvas
            id="navbarScroll"
            aria-labelledby="navbarScrollLabel"
            placement="start"
            className="navbar-drawer"
            backdropClassName="navbar-drawer-backdrop"
          >
            <Offcanvas.Header closeButton closeVariant="white">
              <Offcanvas.Title id="navbarScrollLabel">{t("navbar.menu")}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
            <Nav className="mx-auto" style={{ height: "100%" }}>
              {/* Tienda: link directo a /store en todas las sucursales (el desplegable de marcas y categorías queda oculto) */}
              {tiendaDirecta && (
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/store"
                    className="navbar-capacitaciones-link"
                  >
                    {t("navbar.tienda")}
                  </Nav.Link>
                </Nav.Item>
              )}

              {!tiendaDirecta && country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.tienda")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  show={showDropdown}
                  onToggle={(isOpen) => setShowDropdown(isOpen)}
                >
                  {/* Dropdown de marcas */}
                  <NavDropdown
                    title={t("navbar.marcas")}
                    id="navbarScrollingDropdownMarcas"
                    drop="end"
                    show={showMarcasDropdown}
                    onClick={(e) => handleSubDropdownClick("marcas", e)}
                    autoClose="false"
                  >
                    <div className="dropdown-marcas-grid" onClick={(e) => e.stopPropagation()}>
                      {marcasMapeadas.map((link) => (
                        <NavDropdown.Item
                          key={link.Codigo}
                          as={Link}
                          to={`/marcas/${link.Codigo}`}
                          className="dropdown-item-marcas"
                          onClick={() => {
                            closeAllDropdowns();
                            setShowDropdown(false);
                          }}
                        >
                          {link.Descripcion.toUpperCase()}
                        </NavDropdown.Item>
                      ))}
                    </div>
                  </NavDropdown>

                  {/* Dropdown de categorías */}
                  <NavDropdown
                     title={t("navbar.categorias")}
                     id="navbarScrollingDropdownMarcas"
                     drop="end"
                     show={showCategoriasDropdown}
                     onClick={(e) => handleSubDropdownClick("categorias", e)}
                     autoClose="false"
                  >
                    <div className="dropdown-categorias-grid" onClick={(e) => e.stopPropagation()}>
                      {categorias && Array.isArray(categorias) ? (
                        categorias.map((categoria) => {
                          const tieneHijos = categoria.Hijos && categoria.Hijos.length > 0;
                          return (
                            <div
                              key={categoria.Codigo}
                              className={tieneHijos ? "categoria-con-sub" : "categoria-sin-sub"}
                            >
                              {tieneHijos ? (
                                <CategoryFlyout
                                  categoria={categoria}
                                  toggleClassName="small-toggle"
                                  onNavigate={() => {
                                    closeAllDropdowns();
                                    setShowDropdown(false);
                                  }}
                                />
                              ) : (
                                <NavDropdown.Item
                                  as={Link}
                                  to={`/categorias/${categoria.Codigo}`}
                                  className="dropdown-item-categorias"
                                  onClick={() => {
                                    closeAllDropdowns();
                                    setShowDropdown(false);
                                  }}
                                >
                                  {categoria.Descripcion.toUpperCase()}
                                </NavDropdown.Item>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <p>{t("navbar-categorias-no-disponibles")}</p>
                      )}
                    </div>
                  </NavDropdown>
                </NavDropdown>
              )}

              {/*Dropdown de Nosotros */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.nosotros")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  onClick={() => setShowDropdown(false)}
                >
                  {navbarData.navbarItems[0].items.map((item, index) => (
                    <NavDropdown.Item key={index}>
                      {item.external ? (
                        <a href={item.to} target="_blank" rel="noopener noreferrer" className="dropdown-item mod" 
                           aria-label={`${t(item.label)} - Abre en nueva ventana`}>
                          {t(item.label)}
                        </a>
                      ) : (
                        <Link to={item.to} className="dropdown-item mod">
                          {t(item.label)}
                        </Link>
                      )}
                    </NavDropdown.Item>
                  ))}

                  {/* Contáctanos y Trabaja con nosotros, debajo de La empresa */}
                  <NavDropdown.Item>
                    <Link rel="prefetch" to="/contacto" className="dropdown-item mod">
                      {t("navbar.contacto1")}
                    </Link>
                  </NavDropdown.Item>
                  <NavDropdown.Item>
                    <Link rel="prefetch" to="/trabajaconnosotros" className="dropdown-item mod">
                      {t("navbar.contacto2")}
                    </Link>
                  </NavDropdown.Item>
                </NavDropdown>
              )}

              {/* Dropdown de Links útiles */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <NavDropdown
                  title={t("navbar.links-utiles")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  onClick={() => setShowDropdown(false)}
                >
                  {navbarData.navbarItems[1].items.map((item, index) => (
                    (!item.showArg && !item.showUSA) ||
                      (item.showArg && country === "ARG") ||
                      (item.showUSA && country === "USA") ? (
                      item.url ? (
                        <NavDropdown.Item href={item.url} target="_blank" rel="noopener noreferrer" key={index}>
                          <a href={item.url} className="dropdown-item mod" 
                             aria-label={`${t(item.label)} - Abre en nueva ventana`}>
                            {t(item.label)}
                          </a>
                        </NavDropdown.Item>
                      ) : (
                        item.to && (
                          <NavDropdown.Item as={Link} to={item.to} key={index}>
                            {t(item.label)}
                          </NavDropdown.Item>
                        )
                      )
                    ) : null
                  ))}

                  {/* Dropdown de Política Anticorrupción */}
                  <NavDropdown
                    drop="end"
                    title={t("navbar.subitem-politica")}
                    style={{ textTransform: "uppercase" }}
                    id="navbarScrollingDropdownMarcas"
                  >
                    <NavDropdown.Item href={procPath} target="_blank" 
                                    aria-label="Política Anticorrupción - Abre en nueva ventana">
                      {t("navbar.politicas1")}
                    </NavDropdown.Item>
                    <NavDropdown.Item href={codPath} target="_blank" 
                                    aria-label="Código de Ética - Abre en nueva ventana">
                      {t("navbar.politicas2")}
                    </NavDropdown.Item>
                    <NavDropdown.Item href={manPath} target="_blank">
                      {t("navbar.politicas3")}
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link rel="prefetch" to="/formularioDenuncia" className="dropdown-item mod">
                        {t("navbar.politicas4")}
                      </Link>
                    </NavDropdown.Item>
                  </NavDropdown>
                </NavDropdown>
              )}

              {/* Link / Dropdown de Capacitaciones */}
              {country !== "JM" && country !== "TT" && country !== "PR" && (
                <>
                  {country === "ARG" ? (
                    <NavDropdown
                      title={t("navbar.capacitaciones")}
                      style={{ textTransform: "uppercase" }}
                      id="navbarScrollingDropdown"
                      onClick={() => setShowDropdown(false)}
                    >
                      <NavDropdown.Item as={Link} to="/capacitaciones">
                        VIGENTES
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="https://www.youtube.com/@solutionboxgroup/videos"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Revivi tus webinars - Abre en nueva ventana"
                      >
                        REVIVÍ TUS WEBINARS
                      </NavDropdown.Item>
                    </NavDropdown>
                  ) : (
                    <Nav.Item>
                      <Nav.Link
                        as={Link}
                        to="/capacitaciones"
                        className="navbar-capacitaciones-link"
                      >
                        {t("navbar.capacitaciones")}
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </>
              )}

              {/* Link de Futuros Ingresos - Solo UY */}
              {/* {country === "UY" && (
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/proximos-ingresos"
                    className="navbar-capacitaciones-link"
                  >
                    {t("navbar.futuros-ingresos")}
                  </Nav.Link>
                </Nav.Item>
              )} */}

              {/* API: solo para usuarios logueados */}
              {token && (
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/integracion-api"
                    className="navbar-capacitaciones-link"
                  >
                    {t("navbar.api")}
                  </Nav.Link>
                </Nav.Item>
              )}

              {/* Dropdown de sedes */}
              <NavDropdown
                title={t("navbar.sedes")}
                style={{ textTransform: "uppercase" }}
                id="navbarScrollingDropdown"
              >
                {navbarData.navbarItems[3].items.map((item, index) => (
                  <NavDropdown.Item key={index} href={item.to} target="_blank" className={item.class}>
                    <img src={`${process.env.PUBLIC_URL}${item.image}`} alt={`Bandera ${item.label}`} className="setBanderas" />
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Dropdown de contacto: sus dos items se movieron a "Nosotros".
                  Solo queda en JM, TT y PR, donde "Nosotros" no se muestra. */}
              {!contactoEnNosotros && (
                <NavDropdown
                  title={t("navbar.contacto")}
                  style={{ textTransform: "uppercase" }}
                  id="navbarScrollingDropdown"
                  onClick={() => setShowDropdown(false)}
                >
                  <NavDropdown.Item>
                    <Link rel="prefetch" to="contacto" className="dropdown-item mod">
                      {t("navbar.contacto1")}
                    </Link>
                  </NavDropdown.Item>
                  <NavDropdown.Item>
                    <Link rel="prefetch" to="trabajaconnosotros" className="dropdown-item mod">
                      {t("navbar.contacto2")}
                    </Link>
                  </NavDropdown.Item>
                </NavDropdown>
              )}

              {/* Navlink de OFERTAS */}
              {/* <Nav.Item className="ofertas-navlink-container">
                <Nav.Link
                  style={{ textTransform: "uppercase" }}
                  href="/openbox"
                  className="ofertas-navlink"
                >
                  {t("outlet")}
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
}
